<template functional>
  <div>
    <el-tag :type="$options.ColorType(props)">
      {{ $options.ValueStatus(props) }}
    </el-tag>
  </div>
</template>

<script>
export default {
  name: "ElTag",

  ColorType(props) {
    if (props.rowValue == "ANU") {
      this.status = "ANU";
      return "success";
    } else {
      this.status = "EMI";
      return "danger";
    }
  },

  ValueStatus(props) {
    return props.rowValue;
  }
};
</script>

<style></style>
